import React, { Component } from 'react';

class Loading extends Component {

    render() {
        return (<div className="container-fluid lucidbg text-center">
            <div className="container">
                <h2>
                    <i className="fas fa-spinner-third fa-spin"></i>
                </h2>
                {this.props.message}
                <h3></h3>
            </div>
        </div>)
    }
}
export default Loading;


// WEBPACK FOOTER //
// ./src/pages/Loading.jsx